const contact = () => {
  if ($(".contact").length) {
    if ($('.office-help').children().length % 4 != 0) {
      let count = $('.office-help').children().length % 4;
      if (count != 0) {
        for (let i = 0; i < 4 - count; i++) {
          $('.office-help').append('<div class="col-12 col-lg-3 check-item"></div>');
        }
      }
    }
  }
}

module.exports = contact
